// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper--Sb_","stepperContainer":"Register_stepperContainer--Dzq"};